import ReserveDesk from './ReserveDesk';

export default ReserveDesk;
